/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import classNames from 'classnames';
import urlResolver from 'edrolo/utils/URLResolver';
import chunkGroupClassNames from 'edrolo/utils/chunkGroupClassNames';
import studentLessonProgressLoader from './studentLessonProgressLoader';

@studentLessonProgressLoader
class StudentChunkProgress extends Component {
  renderChunk(chunk, classes) {
    const linkClasses = classNames({
      quiz: chunk.get('question') != null,
      visited: chunk.get('visited'),
    });
    return (
      <li className={classes} key={chunk.get('pk')}>
        <a
          className={linkClasses}
          href={urlResolver.reverse('chunkview-chunk', {
            classId: this.props.classId,
            lessonId: this.props.lessonId,
            index: chunk.get('index'),
          })}
          target="_blank"
          rel="noopener noreferrer"
        >
          {chunk.get('title')}
        </a>
      </li>
    );
  }

  render() {
    const progress = this.props.lessonProgress.lessonProgress;
    const studentId = this.props.studentId;
    const lessonId = this.props.lessonId;
    const chunks = progress.getIn([studentId, lessonId]) || [];

    return (
      <ul className="chunk-progress">
        {chunks.map(function (chunk, i) {
          const classes = chunkGroupClassNames(
            chunk,
            chunks.get(i + 1),
            'chunk'
          );
          return this.renderChunk(chunk, classes);
        }, this)}
      </ul>
    );
  }
}

export default StudentChunkProgress;
